import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "text-subtitle2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Access started")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("User access cannot be removed until")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Current end date")
const _hoisted_7 = { class: "col-auto column" }
const _hoisted_8 = { class: "col self-end" }
const _hoisted_9 = { class: "col-auto q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_link = _resolveComponent("resource-link")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_agreement_swap_member = _resolveComponent("agreement-swap-member")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "q-pa-md q-mb-md" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.member.name), 1),
          _createVNode(_component_resource_link, { resource: _ctx.memberAsResource }, null, 8, ["resource"]),
          _createVNode(_component_q_list, {
            class: "q-mb-lg",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-6 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.member.startDate), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-6 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.member.possibleCancellationDate), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "col-6 text-right text-weight-medium" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.member.endDate), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_badge, {
              color: _ctx.memberAccessStatus.color
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.memberAccessStatus.label), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showButton('swap'))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  label: "Swap",
                  color: "secondary",
                  onClick: _ctx.onSwapMember,
                  unelevated: "",
                  "no-caps": ""
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showButton('cancel'))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  label: _ctx.cancelButtonLabel,
                  color: "warning",
                  onClick: _ctx.onCancelMember,
                  unelevated: "",
                  "no-caps": ""
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showButton('reset-end-date'))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 2,
                  label: "Reset end date",
                  color: "warning",
                  onClick: _ctx.onResetMemberEndDate,
                  unelevated: "",
                  "no-caps": ""
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showButton('purge'))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 3,
                  label: "Purge",
                  color: "negative",
                  onClick: _ctx.onPurgeMember,
                  unelevated: "",
                  "no-caps": ""
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.showSwapMemberDialog,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showSwapMemberDialog) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_agreement_swap_member, {
              agreementId: _ctx.agreementId,
              member: _ctx.member,
              closeDialogCallback: _ctx.onHideSwapMember
            }, null, 8, ["agreementId", "member", "closeDialogCallback"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}